export default "__VITE_ASSET__0IUGkIhY__"